export default __webpack_public_path__ + "static/media/multiple-user.7ca1016c.svg";